import { Button } from 'components/Button'
import { styled } from 'stitches.config'

export type CtaButtonProps = {
  width?: 'large' | 'small' | 'regular' | 'xlarge' | 'xxlarge'
  type?: 'primary' | 'secondary'
}

export const ButtonWidths = {
  xxsmall: {
    maxWidth: '80px',
    '@bp2': {
      maxWidth: '80px',
    },
  },
  xsmall: {
    maxWidth: '120px',
    '@bp2': {
      maxWidth: '120px',
    },
  },
  small: {
    maxWidth: '180px',
    '@bp2': {
      maxWidth: '180px',
    },
  },
  regular: {
    maxWidth: '220px',
    '@bp2': {
      maxWidth: '220px',
    },
  },
  large: {
    maxWidth: '260px',
    '@bp2': {
      maxWidth: '260px',
    },
  },
  xlarge: {
    maxWidth: '300px',
    '@bp2': {
      maxWidth: '300px',
    },
  },
  xxlarge: {
    maxWidth: '340px',
    '@bp2': {
      maxWidth: '340px',
    },
  },
}

export const CtaButton = styled(Button, {
  textTransform: 'uppercase',
  fontSize: '$body',
  padding: 0,
  height: '40px',
  width: '100%',

  '@bp2': {
    height: '42px',
    fontSize: '$bodyLarge',
    letterSpacing: '2px',
  },

  variants: {
    type: {
      primary: {},
      secondary: {
        backgroundColor: '$secondary-100',
        color: '$primary-500',
        '&:hover, &:focus': {
          backgroundColor: '$secondary-100',
          color: '$primary-400',
        },
      },
      outline: {
        backgroundColor: '$transparent',
        color: '$quaternary-200',
        borderStyle: 'solid',
        borderWidth: '2px',
        borderColor: '$quaternary-200',
        '&:hover, &:focus': {
          backgroundColor: '$quaternary-200',
          color: '$accent-white',
        },
      },
    },
    width: ButtonWidths,
  },

  defaultVariants: {
    width: 'regular',
    type: 'primary',
  },
})
